<template>
	<div class="container">
		<div class="header-title" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
			领取凭证
		</div>
		<img class="icon" :src="iconImg" />
		<img class="text" :src="text3Img" />
		<img class="title" :src="titleImg" alt="请填写您的收货地址" />
		<div class="content">
			<div class="input-wrapper">
				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						姓&emsp;&emsp;名：
					</span>
					<input v-model="formData.name" type="text" class="input-field" required placeholder="请输入您的姓名">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						手机号码：
					</span>
					<input v-model="formData.phone" type="text" class="input-field" required placeholder="请输入您的手机号码">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						所在地区：
					</span>
					<input v-model="formData.areaText" type="text" class="input-field" required placeholder="请选择您所在地区" readonly @click="showAreaPopup = true">
				</div>

				<div class="input-group">
					<span class="input-label">
						<span class="required-star">*</span>
						详细地址：
					</span>
					<input v-model="formData.detailAddress" type="text" class="input-field" required placeholder="请输入您的详细地址">
				</div>

				<van-popup v-model="showAreaPopup" position="bottom" round :style="{ height: '40%' }">
					<van-area :area-list="areaList" :value="formData.areaCode" @confirm="onAreaConfirm" @cancel="showAreaPopup = false" title="请选择所在地区" />
				</van-popup>

				<button class="submit-btn" @click="submitAddress" :disabled="loading">
					提交领取资金凭证
				</button>
			</div>
		</div>
		<!-- <span class="tip">
			请认真核对信息，提交后不可修改
		</span> -->
	</div>
</template>

<script>
	import iconImg from '@/assets/icon/claimVouchers/icon.png';
	// import textImg from '@/assets/icon/claimVouchers/text.png';
	import text3Img from '@/assets/icon/claimVouchers/text3.png';
	import titleImg from '@/assets/icon/claimVouchers/title.png';
	import Fetch from '@/utils/fetch';
	import { Popup, Area } from 'vant';
	import { areaList } from '@vant/area-data';

	export default {
		name: "ClaimVouchers",
		components: {
			[Popup.name]: Popup,
			[Area.name]: Area
		},
		data() {
			return {
				iconImg: iconImg,
				// textImg: textImg,
				text3Img: text3Img,
				titleImg: titleImg,
				formData: {
					phone: '',
					name: '',
					areaCode: '', // 地区编码
					areaText: '', // 地区显示文本
					detailAddress: '', // 详细地址
				},
				originalData: null, // 保存原始数据用于比较
				showAreaPopup: false,
				areaList: areaList,
				hasAddress: false, // 是否有地址记录
				loading: false,
				isFirstTime: true // 是否是首次提交
			};
		},
		created() {
			this.$parent.footer('ClaimVouchers', false);
		},
		mounted() {
			// 获取已有地址
			this.getAddress();
		},
		methods: {
			// 获取地址
			getAddress() {
				Fetch('/user/voucher_address_get').then((r) => {
					if (r.code === 1 && r.data) {
						// 有地址数据
						this.hasAddress = true;
						this.isFirstTime = false;
						
						// 将后端返回的地址数据赋值给formData
						this.formData = {
							...this.formData,
							...r.data
						};
						
						// 如果后端返回的地址是一个完整字符串，需要拆分处理
						if (r.data.address) {
							this.splitAddress(r.data.address);
						}
						
						// 保存原始数据，用于比较是否有修改
						this.originalData = {
							...this.formData
						};
					} else {
						// 没有地址或获取失败，说明是首次填写
						this.hasAddress = false;
						this.isFirstTime = true;
						this.originalData = null;
					}
				}).catch(() => {
					this.hasAddress = false;
					this.isFirstTime = true;
					this.originalData = null;
				});
			},
			
			// 拆分地址字符串为地区地址和详细地址
			splitAddress(fullAddress) {
				if (!fullAddress) return;

				// 按空格分割地址字符串
				const parts = fullAddress.split(' ');

				if (parts.length >= 3) {
					// 前三个部分作为省、市、区
					const province = parts[0] || '';
					const city = parts[1] || '';
					const district = parts[2] || '';

					// 拼接省市区作为地区地址
					this.formData.areaText = [province, city, district].filter(Boolean).join(' ');

					// 剩余部分作为详细地址
					this.formData.detailAddress = parts.slice(3).join(' ');
				} else if (parts.length === 2) {
					// 只有两个部分的情况（如直辖市）
					const province = parts[0] || '';
					const city = parts[1] || '';

					this.formData.areaText = [province, city].filter(Boolean).join(' ');
					this.formData.detailAddress = '';
				} else {
					// 只有一个部分或格式不正确
					this.formData.areaText = fullAddress;
					this.formData.detailAddress = '';
				}
			},
			
			// 检查是否有字段被修改
			hasDataChanged() {
				if (!this.originalData) {
					// 首次填写，所有字段都需要
					return true;
				}

				// 检查所有字段是否有修改
				return (
					this.formData.name.trim() !== this.originalData.name ||
					this.formData.phone.trim() !== this.originalData.phone ||
					this.formData.areaText.trim() !== this.originalData.areaText ||
					this.formData.detailAddress.trim() !== this.originalData.detailAddress
				);
			},
			
			// 验证表单
			validateForm() {
				// 验证必填字段
				if (!this.formData.name || !this.formData.phone || !this.formData.areaText || !this.formData.detailAddress) {
					this.$toast({
						className: "toastName",
						message: '请填写完整的收货信息',
					});
					return false;
				}

				// 验证姓名（中文姓名，2-10个汉字）
				const nameRegex = /^[\u4e00-\u9fa5]{2,10}$/;
				if (!nameRegex.test(this.formData.name.trim())) {
					this.$toast({
						className: "toastName",
						message: '请输入正确的姓名（2-10个汉字）',
					});
					return false;
				}

				// 验证手机号格式
				const phoneRegex = /^\d{11}$/;
				if (!phoneRegex.test(this.formData.phone.trim())) {
					this.$toast({
						className: "toastName",
						message: '请输入正确的手机号码',
					});
					return false;
				}

				return true;
			},
			
			// 地区选择确认
			onAreaConfirm(selectedValues) {
				// selectedValues 是选中的地区对象数组
				if (selectedValues && selectedValues.length > 0) {
					// 拼接地区文本
					const areaText = selectedValues.map(area => area.name).join(' ');
					// 获取地区编码（通常是最后一个选中的地区的编码）
					const areaCode = selectedValues[selectedValues.length - 1].code;

					this.formData.areaText = areaText;
					this.formData.areaCode = areaCode;
				}
				this.showAreaPopup = false;
			},
			
			// 提交地址
			submitAddress() {
				// 防止重复提交
				if (this.loading) return;
				
				// 表单验证
				if (!this.validateForm()) {
					return false;
				}
				
				// 如果不是首次提交且数据没有修改，直接跳转
				if (!this.isFirstTime && !this.hasDataChanged()) {
					this.$toast({
						className: "toastName",
						message: '收货信息未修改，正在跳转...',
					});
					
					// 跳转到onlinePayment组件，携带id:8
					setTimeout(() => {
						this.$router.push({
							path: '/onlinePayment',
							query: { id: 8 }
						});
					}, 1000);
					return;
				}

				this.loading = true;
				
				// 构建完整的地址信息
				const fullAddress = {
					name: this.formData.name.trim(),
					phone: this.formData.phone.trim(),
					address: this.formData.areaText.trim() + ' ' + this.formData.detailAddress.trim(), // 合并地区地址和详细地址
				};
				
				Fetch('/user/voucher_address_add', fullAddress).then(res => {
					this.loading = false;
					
					if (res.code === 1) {
						this.$toast({
							className: "toastName",
							message: '收货信息提交成功，正在跳转...',
						});
						
						// 更新状态和原始数据
						this.hasAddress = true;
						this.isFirstTime = false;
						this.originalData = {
							...this.formData
						};
						
						// 跳转到onlinePayment组件，携带id:8
						setTimeout(() => {
							this.$router.push({
								path: '/onlinePayment',
								query: { id: 8 }
							});
						}, 1000);
					} else {
						this.$toast({
							className: "toastName",
							message: res.info['zh_cn'] ? res.info['zh_cn'] : res.info,
						});
					}
				}).catch(error => {
					this.loading = false;
					console.error('提交地址失败:', error);
					this.$toast({
						className: "toastName",
						message: '提交失败，请稍后重试',
					});
				});
			}
		}
	};
</script>

<style scoped>
	.container {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		font-family: "微软雅黑", sans-serif;
		height: 100vh;
		width: 10rem;
		background: url('../../assets/icon/appointmentFailed/bg.jpg') 100% no-repeat;
		background-size: 100% 100%;
		position: relative;
	}

	.header-title {
		position: relative;
		z-index: 1;
		width: 100%;
		text-align: center;
		font-size: 4.8vw;
		font-weight: 600;
		padding: 4vw 0;
		background: #fff;
		box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
		color: #333;
		border-bottom: 1px solid rgba(0, 0, 0, .05);
	}

	.header-title .back-icon {
		position: absolute;
		left: 4vw;
		top: 50%;
		transform: translateY(-50%);
		font-size: 5.33333vw;
		color: #333;
	}

	.icon {
		width: 65%;
		margin-top: 1rem;
	}

	.text {
		width: 90%;
		margin-top: 1rem;
	}

	.title {
		width: 80%;
		margin-top: 0.75rem;
	}

	.content {
		width: 90%;
		border-radius: 12px;
		padding: 20px;
		margin-bottom: 15px;
		box-sizing: border-box;
	}

	.input-wrapper {
		width: 100%;
	}

	.input-group {
		display: flex;
		align-items: center;
		margin-bottom: 15px;
		padding: 10px;
		border-bottom: 1px solid #ebedf0;
		position: relative;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.95);
		box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
	}

	.input-group:last-child {
		border-bottom: none;
		margin-bottom: 10px;
	}

	.input-label {
		font-size: 14px;
		color: #333;
		font-weight: 500;
		text-align: left;
		position: relative;
		display: flex;
		align-items: center;
		white-space: nowrap;
		width: 100px;
	}

	.required-star {
		color: #ee0a24;
		font-size: 14px;
		margin: 0 2px;
		line-height: 1;
	}

	.input-field {
		flex: 1;
		border: none;
		outline: none;
		font-size: 14px;
		background: transparent;
		color: #333;
		padding: 0;
	}

	.input-field:disabled {
		background-color: #f8f8f8;
		color: #666;
		cursor: not-allowed;
	}

	.disabled-input {
		background-color: #f8f8f8 !important;
		color: #666;
		cursor: not-allowed !important;
	}

	.input-field::placeholder {
		color: #969799;
	}

	.submit-btn {
		width: 100%;
		color: #fff;
		font-size: 22px;
		font-weight: bold;
		border-radius: 25px;
		background-color: #134993;
		padding: 10px;
		border: none;
		cursor: pointer;
		margin-top: 10px;
	}

	.submit-btn:disabled {
		background-color: #ccc;
		color: #666;
		cursor: not-allowed;
	}

	.tip {
		color: #7b7b7b;
		font-size: 18px;
		font-weight: bold;
		line-height: 1.2;
		letter-spacing: 1px;
		position: absolute;
		bottom: 2%;
	}

	.tip span {
		color: #134993;
	}
</style>